import * as toastr from "toastr";

export class Toastr {

    public static options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
        "opacity": "1"
      }

    public static Info(title:string, message:string) {
        toastr.options = this.options;
        toastr.info(message, title);
    }

    public static Success(title:string, message:string) {
        toastr.options = this.options;
        toastr.success(message, title);
    }

    public static Warning(title:string, message:string) {
        toastr.options = this.options;
        toastr.warning(message, title);
    }

    public static Error(title:string, message:string) {
        toastr.options = this.options;
        toastr.error(message, title);
    }

}